import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enums";
import { initialRiskProfileV2State } from "./commAutoRiskProfileV2.types";
import {
  fetchRiskProfileV2ListAsync,
  fetchRiskProfileV2Async,
  saveRiskProfileV2Async,
} from "./commAutoRiskProfileV2Actions";

const riskProfileV2Slice = createSlice({
  name: "riskProfileV2",
  initialState: initialRiskProfileV2State,
  reducers: {
    clearRiskProfileV2FormState: (state) => {
      state.form = initialRiskProfileV2State.form;
    },
    clearRiskProfileV2ListState: (state) => {
      state.list = initialRiskProfileV2State.list;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRiskProfileV2ListAsync.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(fetchRiskProfileV2ListAsync.fulfilled, (state, action) => {
        state.list.loading = LoadState.Loaded;
        state.list.data = action.payload.data;
      })
      .addCase(fetchRiskProfileV2ListAsync.rejected, (state, action) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
        state.list.error = action.payload?.message ?? null;
      })

      .addCase(fetchRiskProfileV2Async.pending, (state) => {
        state.form.loading = LoadState.InProgress;
      })
      .addCase(fetchRiskProfileV2Async.fulfilled, (state, action) => {
        state.form.loading = LoadState.Loaded;
        state.form.data = action.payload.data;
      })
      .addCase(fetchRiskProfileV2Async.rejected, (state, action) => {
        state.form.loading = LoadState.Failed;
        state.form.error = action.payload?.message ?? null;
      })

      .addCase(saveRiskProfileV2Async.pending, (state) => {
        state.form.saveLoading = true;
      })
      .addCase(saveRiskProfileV2Async.fulfilled, (state, action) => {
        state.form.saveLoading = false;
        state.form.data = action.payload.data;
      })
      .addCase(saveRiskProfileV2Async.rejected, (state, action) => {
        state.form.saveLoading = false;
        state.form.loading = LoadState.Failed;
        state.form.error = action.payload?.message ?? null;
      });
  },
});

export const { clearRiskProfileV2FormState, clearRiskProfileV2ListState } =
  riskProfileV2Slice.actions;
export const riskProfileV2Reducer = riskProfileV2Slice.reducer;
